import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import './index.css'
// P5 W5 修复：styles/global.css 含 `* { padding: 0 }` + `#root { display: flex }`
// 会把 Tailwind utilities 全打死。旧 pages 已 tsconfig excluded，无需此文件。
// import './styles/global.css'
import { ErrorBoundary } from './components/ErrorBoundary'
import { AppRouter } from './router'
// P5 W4: 注册 auth store 之后 api-client 拦截器才装载
import './stores/auth-store'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
